import { render, staticRenderFns } from "./CvButton.vue?vue&type=template&id=321f9130&scoped=true&"
import script from "./CvButton.vue?vue&type=script&lang=js&"
export * from "./CvButton.vue?vue&type=script&lang=js&"
import style0 from "./CvButton.vue?vue&type=style&index=0&id=321f9130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f9130",
  null
  
)

export default component.exports